import { useEffect } from 'react'

import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { Input } from '@fortem-monorepo/react-ui'

export interface StructureNameFormFieldProps {
  disabled?: boolean
}

export const StructureNameFormField: React.FC<StructureNameFormFieldProps> = ({ disabled }) => {
  const { control, register, watch, setValue } = useFormContext<{ structure_name: string }>()

  const structure_name = watch('structure_name')

  useEffect(() => {
    if (structure_name === '') {
      setValue('structure_name', null as unknown as string, { shouldValidate: true })
    }
  }, [structure_name])

  return (
    <FormField
      name="structure_name"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2 overflow-hidden">
              <FormLabel>Structure Name</FormLabel>
              <FormError />
            </div>
            <Input
              disabled={disabled}
              placeholder={'Structure Name'}
              {...register('structure_name')}
            />
          </FormItem>
        )
      }}
    />
  )
}
